
import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';

/**
 * Generic email sending function using the unified template system
 */
export async function sendEmail(options: {
  to: string;
  subject: string;
  template: string;
  templateData: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
}): Promise<boolean> {
  console.warn("sendEmail is deprecated and no longer used for public contact delivery", options.template);
  return false;
}

/**
 * Generic notification sending function (alias for backward compatibility)
 */
export async function sendNotification(type: string, userId: string, data: Record<string, any>): Promise<void> { // eslint-disable-line @typescript-eslint/no-explicit-any
  try {
    debugLogger.log(`Sending ${type} notification to user:`, userId);

    await platformApiFetch('/v1/notifications', {
      method: 'POST',
      body: JSON.stringify({
      type,
      userId,
      data,
      }),
    });
    debugLogger.log(`${type} notification sent successfully`);
  } catch (error) {
    console.error(`Error in sendNotification:`, error);
  }
}

/**
 * Send welcome email to new user
 */
export async function sendWelcomeEmail(userId: string) {
  try {
    debugLogger.log("Sending welcome email to user:", userId);

    await platformApiFetch('/v1/notifications', {
      method: 'POST',
      body: JSON.stringify({
      type: 'welcome',
      userId,
      }),
    });
    debugLogger.log("Welcome email sent successfully");
  } catch (error) {
    console.error("Error in sendWelcomeEmail:", error);
  }
}

/**
 * Send listing approved email
 */
export async function sendListingApprovedEmail(userId: string, listingName: string) {
  try {
    debugLogger.log("Sending listing approved email to user:", userId);

    await platformApiFetch('/v1/notifications', {
      method: 'POST',
      body: JSON.stringify({
      type: 'listing_approved',
      userId,
      data: {
        listing_name: listingName,
      },
      }),
    });
    debugLogger.log("Listing approved email sent successfully");
  } catch (error) {
    console.error("Error in sendListingApprovedEmail:", error);
  }
}

/**
 * Send listing rejected email
 */
export async function sendListingRejectedEmail(userId: string, listingName: string, reason?: string) {
  try {
    debugLogger.log("Sending listing rejected email to user:", userId);

    await platformApiFetch('/v1/notifications', {
      method: 'POST',
      body: JSON.stringify({
      type: 'listing_rejected',
      userId,
      data: {
        listing_name: listingName,
        rejection_reason: reason,
        reason,
      },
      }),
    });
    debugLogger.log("Listing rejected email sent successfully");
  } catch (error) {
    console.error("Error in sendListingRejectedEmail:", error);
  }
}

/**
 * Send account inactive notification
 */
export async function sendAccountInactiveEmail(userId: string) {
  try {
    debugLogger.log("Sending account inactive email to user:", userId);

    await platformApiFetch('/v1/notifications', {
      method: 'POST',
      body: JSON.stringify({
      type: 'account_inactive',
      userId,
      }),
    });
    debugLogger.log("Account inactive email sent successfully");
    return true;
  } catch (error) {
    console.error("Error in sendAccountInactiveEmail:", error);
    return false;
  }
}
